import React, { useState } from 'react';
import moment from 'moment';
import css from './events_list_modal.module.scss';
import { MdOutlineDateRange, MdAccessTime, MdLocationOn, MdPeople, MdClose, MdSearch } from 'react-icons/md';
import { MdEdit, MdRemoveRedEye } from 'react-icons/md';
import EventDetailModal from './EventDetailModal';

const eventsData = Array.from({ length: 8 }).map((_, i) => {
  const id = i + 1;
  const isUrgent = id % 5 === 0;
  const isMaintenance = id % 7 === 0;
  let priority = "General";
  if (isUrgent) priority = "Urgent";
  else if (isMaintenance) priority = "Maintenance";

  return {
    event_id: id,
    event_name: `Event Title ${id} - Awesome Gathering`,
    event_date: new Date(Date.now() + 1000 * 60 * 60 * 24 * id).toISOString(),
    valid_from: new Date(Date.now() + 1000 * 60 * 60 * 24 * id).toISOString(),
    valid_to: new Date(Date.now() + 1000 * 60 * 60 * (24 * id + 2)).toISOString(),
    priority_level: priority,
    event_details: `This is a dynamically generated mock event description for card number ${id}. It demonstrates how the layout handles multiple lines of text before truncating seamlessly.`,
    visual_assest: `https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=600&auto=format&fit=crop&sig=${id}`,
    created_on: new Date(Date.now() - 1000 * 60 * 60 * id)
  };
});

const days = ['All', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const EventsListModal = ({ open, onClose }) => {
  const [activeTab, setActiveTab] = useState('All');
  const [search, setSearch] = useState('');
  const [selectedEvent, setSelectedEvent] = useState(null);

  if (!open) return null;

  return (
    <div className={css.overlay}>
      <div className={css.modal} onClick={(e) => e.stopPropagation()}>
        <div className={css.header}>
          <div>
            <h1 className={css.title}>Upcoming Events</h1>
            <p className={css.subtitle}>Browse and enroll in your upcoming learning sessions</p>
          </div>
          <button className={css.close_btn} onClick={onClose}><MdClose size={24} /></button>
        </div>

        <div className={css.toolbar}>
          <div className={css.search_box}>
            <MdSearch size={20} className={css.search_icon} />
            <input 
              type="text" 
              placeholder="Search by name..." 
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className={css.filter_tabs}>
            {days.map(day => (
              <button 
                key={day} 
                className={`${css.tab} ${activeTab === day ? css.active : ''}`}
                onClick={() => setActiveTab(day)}
              >
                {day}
              </button>
            ))}
          </div>
        </div>

        <div className={css.grid}>
          {eventsData.map((event, index) => {
            const dateObj = moment(event.event_date || event.valid_from || new Date());
            const day = dateObj.format('DD');
            const month = dateObj.format('MMM');
            const startTime = moment(event.valid_from).format('hh:mm A');
            const endTime = moment(event.valid_to).format('hh:mm A');
            const timeRange = `${startTime} - ${endTime}`;

            return (
              <div 
                key={event.event_id} 
                className={css.card}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className={css.card_image_wrapper}>
                  {event.visual_assest ? (
                    <img src={event.visual_assest} alt={event.event_name} />
                  ) : (
                    <div style={{ width: '100%', height: '100%', backgroundColor: '#e2e8f0' }} />
                  )}
                  <div className={css.date_badge}>
                    <span className={css.day}>{day}</span>
                    <span className={css.month}>{month}</span>
                  </div>
                </div>
                
                <div className={css.card_content}>
                  <div className={css.card_header_top}>
                    <span className={`${css.badge} ${css.badge_general}`}>
                      {event.priority_level || 'General'}
                    </span>
                  </div>
                  
                  <h3 className={css.title}>{event.event_name}</h3>
                  <div className={css.time}>
                    <MdAccessTime size={14} />
                    <span>{timeRange}</span>
                  </div>
                  
                  <p className={css.description}>
                    {event.event_details}
                  </p>
                  
                  <button className={css.edit_button} onClick={(e) => {
                    e.stopPropagation();
                    setSelectedEvent(event);
                  }}>
                    View Event
                  </button>
                </div>
                
                <div className={css.card_footer}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#94a3b8', fontSize: '12px' }}>
                    <MdRemoveRedEye size={14} /> Read by {Math.floor(Math.random() * 100) + 20}
                  </div>
                  <span style={{ color: '#94a3b8', fontSize: '12px' }}>
                    {moment(event.created_on).fromNow()}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {selectedEvent && (
        <EventDetailModal open={true} onClose={() => setSelectedEvent(null)} eventData={selectedEvent} />
      )}
    </div>
  );
};

export default EventsListModal;
